// **************************************************************************************

var electricProductTimerDeadlineHour   = 11;
var electricProductTimerDeadlineMinute = 0;
var electricProductTimerExcludeDays    = [0,6]; // 0 = Sunday , 6 = Saturday

var electricProductTimerText = '';

// **************************************************************************************

jQuery( document ).ready( electricShopReady );

// **************************************************************************************

function electricShopReady() {

	// Wrap shop tables with a wrapper div.
	jQuery( 'body:not(.wp-customizer):not(.wp-admin) .shop_table' ).wrap( '<div class="shop-table-wrapper generated"></div>' );

	// Remove hard-coded zoom icon from product photos.
	jQuery( '.woocommerce-product-gallery__trigger' ).html( '' );

	// Initialise the search button.
	jQuery( '.search-button' ).on( 'click', electricShopToggleSearchBox );

	// Initialise the product quantity buttons.
	jQuery( '.product-details-wrapper .quantity' ).prepend( '<div class="quantity-button quantity-subtract">-</div>' );
	jQuery( '.product-details-wrapper .quantity' ).append( '<div class="quantity-button quantity-add">+</div>' );

	jQuery( '.quantity-button.quantity-subtract' ).on( 'click', electricShopDecreaseQuantity )
	jQuery( '.quantity-button.quantity-add' ).on( 'click', electricShopIncreaseQuantity )

	if( jQuery( 'body' ).hasClass( 'single-product' ) ) {
		// Initialise the product timer.
		electricProductTimerText = jQuery( '.product-timer-wrapper div' ).html();
		electricUpdateProductTimer();
		setInterval(electricUpdateProductTimer, 1000);
	}

}

// **************************************************************************************

function electricUpdateProductTimer() {

	var nextDay = new Date();
	nextDay.setDate(nextDay.getDate() + 1);
	var day = nextDay.getDay();
	while(electricProductTimerExcludeDays.includes(day)) {
		day++;
		if(7===day) {
			day = 0;
		}
		nextDay.setDate(nextDay.getDate() + 1);
	}
	nextDay.setHours(electricProductTimerDeadlineHour);
	nextDay.setMinutes(electricProductTimerDeadlineMinute);
	nextDay.setSeconds(0);

	var now = new Date();
	var diff = nextDay - now;
	var diffHour = Math.floor(diff / 1000 / 60 / 60);
	diff -= diffHour * 1000 * 60 * 60;
	var diffMinutes = Math.floor(diff / 1000 / 60);
	diff -= diffMinutes * 1000 * 60;
	var diffSeconds = Math.floor(diff / 1000);

	var text = electricProductTimerText.replace( '{h}', diffHour );
	text = text.replace( '{m}', diffMinutes );
	text = text.replace( '{s}', diffSeconds );
	jQuery( '.product-timer-wrapper div' ).html( text);

}

// **************************************************************************************

function electricShopDecreaseQuantity() {

	var inputBox = jQuery('.product-details-wrapper .quantity input');
	var quantity = jQuery(inputBox)[0].value;
	if( quantity > 1 ) {
		quantity--;
	}
	jQuery(inputBox)[0].value = quantity;
}

// **************************************************************************************

function electricShopIncreaseQuantity() {

	var inputBox = jQuery('.product-details-wrapper .quantity input');
	var quantity = jQuery(inputBox)[0].value;
	var max = jQuery(inputBox)[0].max;
	if( quantity < max ) {
		quantity++;
	}
	jQuery(inputBox)[0].value = quantity;
}

// **************************************************************************************

function electricShopToggleSearchBox( e ) {

	if( 'IMG' === jQuery( e.target ).prop( 'tagName' ) ) {
		jQuery( '.popup-search-box' ).toggleClass( 'visible' );
	}

}

// **************************************************************************************
